import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Dropdown,
  Button,
  Checkbox,
  Input,
  TextArea
} from 'semantic-ui-react'

const CardSettingQueueUX = (props: any) => {
    return(
      <div
        id="CardSettingQueueUX-div-0"
        style={{ margin: "15px" }}>
        <div
          id="CardSettingQueueUX-div-1"
          style={{padding: "10px 10px 15px", fontSize: "1.2rem", fontWeight: "bold" ,display: "flex", alignItems: "center" }}>
          {props.languageUX === "en" ? "Clinic patient waiting queue notification table (automatic)" : "ตารางแจ้งเตือนคิวรอรับบริการให้ผู้ป่วยของคลินิก (อัตโนมัติ)"}
        </div>
        <div
          id="CardSettingQueueUX-div-2"
          style={{display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          
          <div
            id="CardSettingQueueUX-div-51"
            style={{ display: "flex", alignItems:  "center", width: "50%" }}>
            
            <div
              id="CardSettingQueueUX-div-53"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "department" : "แผนก"}
            </div>
            <Dropdown
              clearable={true}
              id="CardSettingQueueUX-Dropdown-54"
              multiple={true}
              onChange={props.handleChangeValue("searchDivision")}
              options={props.divisionOptions}
              search={true}
              selection={true}
              style={{ marginRight: "20px", width: "100%" }}
              value={props.notificationQueueOrder?.searchDivision}>
            </Dropdown>
            <Button
              color="teal"
              id="CardSettingQueueUX-Button-55"
              onClick={props.onSearchNotificationMessage}
              size="small">
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
          </div>
          <div
            id="CardSettingQueueUX-div-52">
            
            <Button
              color="green"
              id="CardSettingQueueUX-Button-56"
              onClick={props.onOpenSettingQueue}
              size="small">
              {props.languageUX === "en" ? "Add queue definition" : "เพิ่มการกำหนดคิว"}
            </Button>
          </div>
        </div>
        <Table
          data={props.notificationQueue}
          headers="แผนก,จำนวนผู้ป่วยถูกเรียก/ครั้ง,รูปแบบข้อความ,แก้ไข,ลบ"
          keys="division,count,typeText,edit,delete"
          minRows="5"
          showPagination={false}
          style={{height: "300px", marginTop: "0.5rem"}}
          widths="{ ....,...,...,100px,100px }">
        </Table>
        <div
          id="CardSettingQueueUX-div-66"
          style={{ margin: "20px 0px", padding: "20px", border:  "1.5px solid rgba(26, 179, 203, 1)", ...(!props.openSettingQueue && {display: "none" }) }}>
          
          <div
            id="CardSettingQueueUX-div-104">
            {props.errorRemind}
          </div>
          <div
            id="CardSettingQueueUX-div-67"
            style={{display: "flex", alignItems: "center", width: "55%" }}>
            
            <div
              id="CardSettingQueueUX-div-68"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "department" : "แผนก"}
            </div>
            <Dropdown
              clearable={true}
              id="CardSettingQueueUX-Dropdown-69"
              multiple={true}
              onChange={props.handleChangeValue("selectDivision")}
              options={props.divisionOptions}
              search={true}
              selection={true}
              style={{ marginRight: "20px", width: "70%" , display: props.notificationQueueOrder?.selectAllDivision && "none"}}
              value={props.notificationQueueOrder?.selectDivision }>
            </Dropdown>
            <Input
              id="CardSettingQueueUX-Input-87"
              readOnly="true"
              style={{ marginRight: "20px", width: "70%" , display: !props.notificationQueueOrder?.selectAllDivision && "none"}}
              value="ืทั้งหมด">
            </Input>
            <Checkbox
              checked={props.notificationQueueOrder?.selectAllDivision}
              id="CardSettingQueueUX-Checkbox-70"
              label={props.languageUX === "en" ? "All Departments" : "แผนกทั้งหมด"}
              name="selectAllDivision"
              onChange={props.handleChangeSelectAllDivision}>
            </Checkbox>
          </div>
          <div
            id="CardSettingQueueUX-div-71"
            style={{display: "flex", alignItems: "center", width: "55%", marginTop: "20px" }}>
            
            <div
              id="CardSettingQueueUX-div-72"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "Number of patients called/time" : "จำนวนผู้ป่วยถูกเรียก/ครั้ง"}
            </div>
            <Input
              id="CardSettingQueueUX-Input-73"
              min="0"
              onChange={props.handleChangeValuePatientCount}
              type="number"
              value={props.notificationQueueOrder?.patientCount || 0}>
            </Input>
          </div>
          <div
            id="CardSettingQueueUX-div-80"
            style={{ display: "flex", justifyContent: "space-between", marginTop: "20px" }}>
            
            <div
              id="CardSettingQueueUX-div-81"
              style={{display: "flex", width: "80%", }}>
              
              <div
                id="CardSettingQueueUX-div-83"
                style={{ fontWeight: "bold" ,marginRight: "20px" }}>
                {props.languageUX === "en" ? "message" : "ข้อความ"}
              </div>
              <TextArea
                id="CardSettingQueueUX-TextArea-84"
                onChange={props.handleChangeValue("notificationDetail")}
                rows="3"
                style={{ width: "100%", resize: "none" }}
                value={props.notificationQueueOrder?.notificationDetail}>
              </TextArea>
            </div>
            <div
              id="CardSettingQueueUX-div-82"
              style={{ display: "flex", alignItems: "flex-end" }}>
              
              <Button
                color="green"
                id="CardSettingQueueUX-Button-85"
                onClick={props.onSaveSettingQueue}
                size="small"
                style={{ margin: "0px 10px" }}>
                {props.languageUX === "en" ? "record" : "บันทึก"}
              </Button>
              <Button
                color="red"
                id="CardSettingQueueUX-Button-86"
                onClick={props.onCloseSettingQueue}
                size="small">
                {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
              </Button>
            </div>
          </div>
        </div>
        <div
          id="CardSettingQueueUX-div-57"
          style={{padding: "10px 10px 15px", fontSize: "1.2rem", fontWeight: "bold" ,display: "flex", alignItems: "center", marginTop: "40px" }}>
          {props.languageUX === "en" ? "Table showing message format groups for sending to patients via mobile applications" : "ตารางแสดงกลุ่มรูปแบบข้อความสำหรับส่งให้ผู้ป่วยผ่านโมบายแอพพลิเคชัน"}
        </div>
        <div
          id="CardSettingQueueUX-div-58"
          style={{display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          
          <div
            id="CardSettingQueueUX-div-59"
            style={{ display: "flex", alignItems:  "center", width: "50%" }}>
            
            <div
              id="CardSettingQueueUX-div-61"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "department" : "แผนก"}
            </div>
            <Dropdown
              clearable={true}
              id="CardSettingQueueUX-Dropdown-63"
              multiple={true}
              onChange={props.handleChangeMessageTemplate("searchDivision")}
              options={props.divisionOptions}
              search={true}
              selection={true}
              style={{ marginRight: "20px", width: "100%" }}
              value={props.messageTemplateOrder?.searchDivision}>
            </Dropdown>
            <Button
              color="teal"
              id="CardSettingQueueUX-Button-64"
              onClick={props.onSearchMessageTemplate}
              size="small">
              {props.languageUX === "en" ? "Search" : "ค้นหา"}
            </Button>
          </div>
          <div
            id="CardSettingQueueUX-div-60">
            
            <Button
              color="green"
              id="CardSettingQueueUX-Button-65"
              onClick={props.onOpenMessageTemplate}
              size="small">
              {props.languageUX === "en" ? "Add text formatting" : "เพิ่มรูปแบบข้อความ"}
            </Button>
          </div>
        </div>
        <Table
          data={props.messageTemplateQueue}
          headers="หัวข้อ,รายละเอียด,แผนก,แก้ไข,ลบ"
          id="CardSettingQueueUX-Table-62"
          keys="header,detail,division,edit,delete"
          minRows="5"
          showPagination={false}
          style={{height: "300px", marginTop: "0.5rem"}}
          widths="{ ...,...,...,100px,100px }">
        </Table>
        <div
          id="CardSettingQueueUX-div-88"
          style={{ margin: "20px 0px", padding: "20px", border:  "1.5px solid rgba(26, 179, 203, 1)", ...(!props.openMessageTemplate && {display: "none" }) }}>
          
          <div
            id="CardSettingQueueUX-div-105">
            {props.errorTemplate}
          </div>
          <div
            id="CardSettingQueueUX-div-89"
            style={{display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between" }}>
            
            <div
              id="CardSettingQueueUX-div-92"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "section" : "หัวข้อ"}
            </div>
            <Input
              id="CardSettingQueueUX-Input-99"
              onChange={props.handleChangeMessageTemplate("header")}
              style={{  width: "90%", }}
              value={props.messageTemplateOrder?.header}>
            </Input>
          </div>
          <div
            id="CardSettingQueueUX-div-90"
            style={{display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between", marginTop: "20px" }}>
            
            <div
              id="CardSettingQueueUX-div-94"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "details" : "รายละเอียด"}
            </div>
            <Input
              id="CardSettingQueueUX-Input-100"
              onChange={props.handleChangeMessageTemplate("detail")}
              style={{ width: "90%" }}
              value={props.messageTemplateOrder?.detail}>
            </Input>
          </div>
          <div
            id="CardSettingQueueUX-div-91"
            style={{display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between", marginTop: "20px" }}>
            
            <div
              id="CardSettingQueueUX-div-96"
              style={{ fontWeight: "bold" ,marginRight: "20px" }}>
              {props.languageUX === "en" ? "department" : "แผนก"}
            </div>
            <Dropdown
              clearable={true}
              id="CardSettingQueueUX-Dropdown-101"
              multiple={true}
              onChange={props.handleChangeMessageTemplate("selectDivision")}
              options={props.divisionOptions}
              search={true}
              selection={true}
              style={{ width: "90%" }}
              value={props.messageTemplateOrder?.selectDivision}>
            </Dropdown>
          </div>
          <div
            id="CardSettingQueueUX-div-98"
            style={{display: "flex", alignItems: "center", width: "100%", justifyContent: "flex-end", marginTop: "20px" }}>
            
            <Button
              color="green"
              id="CardSettingQueueUX-Button-102"
              onClick={props.onSaveMessageTemplate}
              size="small"
              style={{ margin: "0px 10px" }}>
              {props.languageUX === "en" ? "record" : "บันทึก"}
            </Button>
            <Button
              color="red"
              id="CardSettingQueueUX-Button-103"
              onClick={props.onCloseMessageTemplate}
              size="small">
              {props.languageUX === "en" ? "cancel" : "ยกเลิก"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardSettingQueueUX

export const screenPropsDefault = {"price_claimable":0,"price_non_claimable":0,"price_total":0}

/* Date Time : Wed Oct 01 2025 11:59:50 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ตารางแจ้งเตือนคิวรอรับบริการให้ผู้ป่วยของคลินิก (อัตโนมัติ)",
          "valueEN": "Clinic patient waiting queue notification table (automatic)"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 15px\", fontSize: \"1.2rem\", fontWeight: \"bold\" ,display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 10,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.notificationQueue"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "แผนก,จำนวนผู้ป่วยถูกเรียก/ครั้ง,รูปแบบข้อความ,แก้ไข,ลบ"
        },
        "id": {
          "type": "value",
          "value": ""
        },
        "keys": {
          "type": "value",
          "value": "division,count,typeText,edit,delete"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\", marginTop: \"0.5rem\"}"
        },
        "widths": {
          "type": "value",
          "value": "{ ....,...,...,100px,100px }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems:  \"center\", width: \"50%\" }"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Dropdown",
      "parent": 51,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Dropdown-54"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": ""
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"searchDivision\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.notificationQueueOrder?.searchDivision"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Button",
      "parent": 51,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Button-55"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchNotificationMessage"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Button",
      "parent": 52,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มการกำหนดคิว",
          "valueEN": "Add queue definition"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Button-56"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenSettingQueue"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ตารางแสดงกลุ่มรูปแบบข้อความสำหรับส่งให้ผู้ป่วยผ่านโมบายแอพพลิเคชัน",
          "valueEN": "Table showing message format groups for sending to patients via mobile applications"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 10px 15px\", fontSize: \"1.2rem\", fontWeight: \"bold\" ,display: \"flex\", alignItems: \"center\", marginTop: \"40px\" }"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\" }"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-59"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems:  \"center\", width: \"50%\" }"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-60"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-61"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 62,
      "name": "Table",
      "parent": 0,
      "props": {
        "data": {
          "type": "code",
          "value": "props.messageTemplateQueue"
        },
        "headers": {
          "type": "value",
          "value": "หัวข้อ,รายละเอียด,แผนก,แก้ไข,ลบ"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Table-62"
        },
        "keys": {
          "type": "value",
          "value": "header,detail,division,edit,delete"
        },
        "minRows": {
          "type": "value",
          "value": "5"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"300px\", marginTop: \"0.5rem\"}"
        },
        "widths": {
          "type": "value",
          "value": "{ ...,...,...,100px,100px }"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Dropdown",
      "parent": 59,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Dropdown-63"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeMessageTemplate(\"searchDivision\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"100%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.messageTemplateOrder?.searchDivision"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Button",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Button-64"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSearchMessageTemplate"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 65,
      "name": "Button",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "เพิ่มรูปแบบข้อความ",
          "valueEN": "Add text formatting"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Button-65"
        },
        "onClick": {
          "type": "code",
          "value": "props.onOpenMessageTemplate"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-66"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"20px 0px\", padding: \"20px\", border:  \"1.5px solid rgba(26, 179, 203, 1)\", ...(!props.openSettingQueue && {display: \"none\" }) }"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"55%\" }"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Dropdown-69"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectDivision\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"70%\" , display: props.notificationQueueOrder?.selectAllDivision && \"none\"}"
        },
        "value": {
          "type": "code",
          "value": "props.notificationQueueOrder?.selectDivision "
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Checkbox",
      "parent": 67,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.notificationQueueOrder?.selectAllDivision"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Checkbox-70"
        },
        "label": {
          "type": "value",
          "value": "แผนกทั้งหมด",
          "valueEN": "All Departments"
        },
        "name": {
          "type": "value",
          "value": "selectAllDivision"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeSelectAllDivision"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"55%\", marginTop: \"20px\" }"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "จำนวนผู้ป่วยถูกเรียก/ครั้ง",
          "valueEN": "Number of patients called/time"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Input",
      "parent": 71,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Input-73"
        },
        "min": {
          "type": "value",
          "value": "0"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValuePatientCount"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.notificationQueueOrder?.patientCount || 0"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-80"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", justifyContent: \"space-between\", marginTop: \"20px\" }"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", width: \"80%\", }"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-82"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 81,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อความ",
          "valueEN": "message"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 84,
      "name": "TextArea",
      "parent": 81,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-TextArea-84"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"notificationDetail\")"
        },
        "rows": {
          "type": "value",
          "value": "3"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"100%\", resize: \"none\" }"
        },
        "value": {
          "type": "code",
          "value": "props.notificationQueueOrder?.notificationDetail"
        }
      },
      "seq": 84,
      "void": true
    },
    {
      "from": "semantic-ui-react",
      "id": 85,
      "name": "Button",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Button-85"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveSettingQueue"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Button",
      "parent": 82,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Button-86"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseSettingQueue"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "Input",
      "parent": 67,
      "props": {
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Input-87"
        },
        "readOnly": {
          "type": "value",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"20px\", width: \"70%\" , display: !props.notificationQueueOrder?.selectAllDivision && \"none\"}"
        },
        "value": {
          "type": "value",
          "value": "ืทั้งหมด"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"20px 0px\", padding: \"20px\", border:  \"1.5px solid rgba(26, 179, 203, 1)\", ...(!props.openMessageTemplate && {display: \"none\" }) }"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"100%\", justifyContent: \"space-between\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"100%\", justifyContent: \"space-between\", marginTop: \"20px\" }"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"100%\", justifyContent: \"space-between\", marginTop: \"20px\" }"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "value",
          "value": "หัวข้อ",
          "valueEN": "section"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-92"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 90,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียด",
          "valueEN": "details"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\" ,marginRight: \"20px\" }"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", width: \"100%\", justifyContent: \"flex-end\", marginTop: \"20px\" }"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Input",
      "parent": 89,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Input-99"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeMessageTemplate(\"header\")"
        },
        "style": {
          "type": "code",
          "value": "{  width: \"90%\", }"
        },
        "value": {
          "type": "code",
          "value": "props.messageTemplateOrder?.header"
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "Input",
      "parent": 90,
      "props": {
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Input-100"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeMessageTemplate(\"detail\")"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"90%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.messageTemplateOrder?.detail"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Dropdown",
      "parent": 91,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Dropdown-101"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeMessageTemplate(\"selectDivision\")"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"90%\" }"
        },
        "value": {
          "type": "code",
          "value": "props.messageTemplateOrder?.selectDivision"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Button",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "record"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Button-102"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveMessageTemplate"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Button",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิก",
          "valueEN": "cancel"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-Button-103"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCloseMessageTemplate"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorRemind"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-104"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 88,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorTemplate"
        },
        "id": {
          "type": "value",
          "value": "CardSettingQueueUX-div-105"
        }
      },
      "seq": 89,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 90,
  "isMounted": false,
  "memo": false,
  "name": "CardSettingQueueUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "price_claimable": 0,
    "price_non_claimable": 0,
    "price_total": 0
  },
  "width": 55
}

*********************************************************************************** */
